module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0097.jpg?v=d1f9805c";